import { Location } from '@angular/common';
import {
    ChangeDetectorRef,
    Component,
    ElementRef,
    HostListener,
    OnDestroy,
    OnInit,
    Renderer2,
    ViewChild,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Calendar } from 'primeng/calendar';
import { Paginator } from 'primeng/paginator';
import {
    BehaviorSubject,
    debounceTime,
    distinctUntilChanged,
    filter,
    forkJoin,
    map,
    Observable,
    scan,
    skip,
    Subject,
    Subscription,
    switchMap,
    take,
    takeUntil,
} from 'rxjs';
import {
    Category,
    CompanyName,
    conditions,
    Filter,
    PageEvent,
    PriceProduct,
    UrlImage,
} from 'src-adisco/interfaces/categories';
import { ComparatorRepository } from 'src-adisco/repositories/comparator.repository';
import { CommonService } from 'src-adisco/services/common.service';
import { FilterService } from 'src-adisco/services/filter.service';
import { HomepageService } from 'src-adisco/services/homepage.service';
import {
    buildCategoryHierarchyRandom,
    buildUrlWithNewParams,
    findCategoryByTree,
    findMatchingNodes,
    flatCategories,
    getProductsInCategory,
    handleRemoveProperties,
    removeDuplicatesAndSort
} from 'src-adisco/utils/categories';
import { DynamicReferencedFilterParam } from 'src-ironside/repositories/supplier.repository';
import { ERole, UserService } from 'src/app/admin/core/services/user.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
    selector: 'app-categories',
    templateUrl: 'categories.component.html',
    styleUrls: ['./categories.component.css'],
    providers: [MessageService, ConfirmationService],
})
export class CategoriesComponent implements OnInit, OnDestroy {
    titleCategory = '';
    codeCategoryCurrent = ''
    idRootCategory = '';
    titleCategoryImage = 'src-adisco/assets/images/image-default.jpeg';
    transformedArray: Category[] = [];
    listNameCompany: CompanyName[] = [];
    @ViewChild('paginator1', { static: false }) paginator1: Paginator;
    @ViewChild('paginator2', { static: false }) paginator2: Paginator;
    @ViewChild('wrapFilter') wrapFilter: ElementRef | undefined;
    @ViewChild('wrapFilterInner') wrapFilterInner: ElementRef | undefined;
    @ViewChild('wrapContent') wrapContent: ElementRef | undefined;
    @ViewChild('containerCategories') containerCategories: ElementRef | undefined;
    isToggleable: boolean = false;
    isOpenOuvert: boolean = false;
    isOpenFeme: boolean = false;
    cli: string = 'non';
    formFilter!: FormGroup;
    formPagination!: FormGroup;

    femeControl = new FormControl(false);
    ouvertControl = new FormControl(false);
    biocide1Control = new FormControl(false);
    biocide2Control = new FormControl(false);
    foodContact1Control = new FormControl(false);
    foodContact2Control = new FormControl(false);
    clpSafetyPicto1Control = new FormControl(false);
    clpSafetyPicto2Control = new FormControl(false);
    checkListBySupplier = false;
    loadingStatus = false;
    currentUrl: string;
    totalPages = 0;
    listCountry: any[] = [];
    listProduct: any[] = [];
    scrollYPosition = 0;
    condition = false;
    listSustainableDevelopment: any[] = [
        { id: 1, label: 'Austrian Ecolabel', name: 'austrianEcolabel' },
        { id: 2, label: 'Cradle to Cradle (C2C)', name: 'cradleToCradle' },
        { id: 3, label: 'Ecocert', name: 'ecocert' },
        { id: 4, label: 'EMAS', name: 'emas' },
        { id: 5, label: 'European Ecolabel', name: 'europeanEcolabel' },
        { id: 6, label: 'FSC', name: 'fsc' },
        { id: 7, label: 'Nordic Swan', name: 'nordicSwan' },
        { id: 8, label: 'REACH', name: 'reach' },
    ];

    listAutresInformations: any[] = [
        { id: 1, label: 'Sans CLP', name: 'clpSafetyPicto', conditionValue: 'SANS' },
        { id: 2, label: 'Contact alimentaire', name: 'foodContact', conditionValue: true },
        { id: 3, label: 'Non biocide', name: 'biocide', conditionValue: false },
    ];

    isExportSuccessFirst: boolean = false;

    listUrlImageProduct: UrlImage[] = [];
    listRows: any[] = [12, 24, 48];
    first1: number = 0;
    rows1: number = 10;
    first2: number = 0;
    rows2: number = 10;
    first3: number = 0;
    rows3: number;
    totalRecords: number;
    rows: number = 1;
    dataFilterProductAccueil: any[] = [];
    idCategory!: any;
    rowsPerPageOptions: number[] = [1, 2, 3];
    idSupplier: string;
    subArrayCategory: any[] = [];
    listNameSuppliers: any[] = [];
    options = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 },
        { label: 120, value: 120 },
    ];
    showListBtn = false;
    detailSupplier!: any;
    statusArray: any[] = [];
    isUpdating = false;
    currentPage = 0;
    checkRouterSupplier = false;
    checkRouterCategories = false;
    checkRouterRechercher = false;
    listIdTariff: any[] = [];
    listPriceProduct: PriceProduct[] = [];
    priceCurrent: any;
    dataRechercher: any;
    listSuppliers: any[] = [];
    listIconFilter: any[] = [];
    comparatorItemList: any[] = [];
    allProductLinkToSupplier: any[] = [];
    lastSaveEventSearchData: any;
    getClickSubEvent: Subscription;
    isSaveFilter: boolean = false;
    userId = localStorage.getItem('userid');
    roleUser = localStorage.getItem('role');
    codeUser = null;
    isSupplierCatalog = false;
    listMemberCatalogSegmentation: any[] = [];
    readyToGetProducts: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    categoriesLevelList = [];
    allCategoriesById: any[] = [];
    visibleDialog = false;
    tempKeyworkSearch = '';
    profileSupplier: any;
    loadingCategory: boolean = false;
    isCollapsed: boolean = true;
    tempKeyworkSearchChange: Subject<string> = new Subject<string>();
    loadingIconStatus: boolean = false;
    loadingExport: { isExportProduct: boolean; isExportTariff: boolean } = {
        isExportProduct: false,
        isExportTariff: false,
    };
    loadingProductList: boolean = false;
    homeUrl: Params

    rangeDates: any;
    defaultImg = 'src-adisco/assets/images/image-default.jpeg';
    currentIdCategory: string;

    progress: number = 0;
    fileId: string;

    @ViewChild('calendar') calendar: Calendar;

    private destroy$: Subject<void> = new Subject<void>();

    constructor(
        private _fb: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        public _commonService: CommonService,
        private dynamicDocumentService: DynamicDocumentService,
        private _homepageService: HomepageService,
        private _cdf: ChangeDetectorRef,
        private comparatorRepository: ComparatorRepository,
        private _messageService: MessageService,
        private _notificationService: NotificationService,
        private _location: Location,
        protected userService: UserService,
        private profileService: ProfileService,
        private filterService: FilterService,
        private renderer: Renderer2
    ) {
        this.getFilterFromUrl();
        this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };
        this.route.params.subscribe((params) => {
            this.currentIdCategory = params['id'];
        });

        this.router.events.pipe(takeUntil(this.destroy$)).subscribe((evt) => {
            if (evt instanceof NavigationEnd) {
                this.router.navigated = false;
                window.scrollTo(0, 0);

                const preUrl = this._commonService.getPreUrl();
                const curUrl = evt?.url ?? '';

                // process
                if (
                    preUrl.includes('/catalogues/product-detail/') &&
                    curUrl.includes('/catalogues/')
                ) {
                    this.isSaveFilter = true;
                }

                this.initForm(this.isSaveFilter);

                const savedFilters = this.filterService.getFilters();
                if (savedFilters) {
                    this.formFilter.patchValue(savedFilters);
                    this.renderIconFilter();
                }

                // end process
                if (this.userId) {
                    this.loadingProductList = true;
                    // Fetch user profile using ProfileService (with caching)
                    this.profileService
                        .getUserProfile(this.userId)
                        .pipe(
                            filter((res) => !!res.email),
                            map((currentUser) => {
                                const linkToLegalEntityId =
                                    currentUser?.linkToLegalEntity?.documentId ?? '';
                                return linkToLegalEntityId as string;
                            })
                        )
                        .subscribe((linkToLegalEntityId) => {
                            // Fetch member info using ProfileService (with caching)
                            /* this.profileService.getMemberInfo(linkToLegalEntityId) */
                            this._commonService.getInfoMember(linkToLegalEntityId).subscribe({
                                next: (res) => {
                                    this.profileSupplier = res;
                                    // Process member catalog segmentation
                                    this.listMemberCatalogSegmentation =
                                        res?.memberCatalogSegmentation?.map(
                                            (seg: any) => seg?.value
                                        ) ?? [];
                                    this.codeUser = res?.code;

                                    // Handle supplier information
                                    if (
                                        !this.idSupplier &&
                                        this.roleUser === ERole.Supplier &&
                                        this.codeUser
                                    ) {
                                        this.idSupplier = this.codeUser;
                                        this.isSupplierCatalog = true;
                                    }

                                    // Get the last saved filter data
                                    const lastFilterData =
                                        this._commonService.getFilterByKey('categories');

                                    if (this.isSaveFilter && lastFilterData) {
                                        // Filter out null/undefined values from lastFilterData
                                        const filteredObj = Object.fromEntries(
                                            Object.entries(lastFilterData).filter(
                                                ([key, value]) =>
                                                    value !== null &&
                                                    value !== undefined &&
                                                    value !== ''
                                            )
                                        );

                                        // Conditionally remove 'longDescription' if not in the search page
                                        if (!curUrl.includes('/catalogues/rechercher')) {
                                            delete filteredObj['longDescription'];
                                        }

                                        // Handle specific URL cases
                                        if (
                                            curUrl.includes('/catalogues/rechercher') ||
                                            curUrl.includes('/catalogues/suppliers/')
                                        ) {
                                            this.dataRechercher = { ...filteredObj };
                                            if (this.dataRechercher?.categoryProduct) {
                                                this.idCategory =
                                                    this.dataRechercher.categoryProduct;
                                            }
                                        }

                                        // Ready to fetch products and load categories
                                        this.readyToGetProducts.next(true);
                                        //this.loadCategories();

                                        // Patch the form filter with filtered data
                                        setTimeout(() => {
                                            this.formFilter.patchValue(filteredObj);
                                        }, 1);
                                    } else {
                                        // Default: fetch products and load categories
                                        this.readyToGetProducts.next(true);
                                        //this.loadCategories();
                                    }

                                    this.fetchAllCategories();
                                },
                                error: (error) => {
                                    // Handle errors if any
                                    console.error('Error fetching member info:', error);
                                },
                            });
                        });
                }

                this._commonService.setPreUrl(curUrl);
            }
        });

        this.readyToGetProducts.pipe(takeUntil(this.destroy$)).subscribe((ready) => {
            if (ready) {
                this.getListCountry();


                this.tempKeyworkSearchChange
                    .pipe(debounceTime(600), distinctUntilChanged(), takeUntil(this.destroy$))
                    .subscribe((searchValue) => {
                        this.onApplySearch(searchValue);
                    });

                this._commonService
                    .getAllCategories()
                    .pipe(takeUntil(this.destroy$))
                    .subscribe((allCates: any) => {
                        if (allCates) {
                            this.allCategoriesById = { ...allCates };

                            if (this.idRootCategory) {
                                this.refreshBreadcrumbs(this.idRootCategory);
                            }
                        }
                    });

                this.formFilter.valueChanges
                    .pipe(debounceTime(600), takeUntil(this.destroy$))
                    .subscribe((val) => {
                        this.formPagination.patchValue({
                            rows: this.formPagination.value.rows,
                            page: 1,
                        });

                        this.listNameSuppliers = [];
                        if (val) {
                            if (val.fournisseur?.length > 0) {
                                val.fournisseur.forEach((item: any) => {
                                    this.listNameSuppliers.push(item);
                                });
                            }

                            this.paginator1?.changePage(0);

                            if (this.isUpdating == false) {
                                this.filterProduct();
                            }
                        }
                        this.listIconFilter = [];

                        if (this.formFilter.value.countryOfManufacture) {
                            this.listIconFilter.push({
                                value: this.formFilter.value.countryOfManufacture,
                                type: 'countryOfManufacture',
                            });
                        }

                        if (this.formFilter?.value?.categoryProduct) {
                            let nameCatalog = '';
                            this._commonService.getFlatCategories().subscribe((res: Category[]) => {
                                if (res) {
                                    nameCatalog = res?.filter(
                                        (el) =>
                                            el?.codeCategory ===
                                            this.formFilter?.value?.categoryProduct
                                    )?.[0]?.nameCategory?.fr_FR;

                                    const iscategoryProductDuplicate = this.listIconFilter.some(
                                        (icon) => icon.type === 'categoryProduct'
                                    );
                                    if (!iscategoryProductDuplicate) {
                                        this.listIconFilter.push({
                                            value: nameCatalog,
                                            type: 'categoryProduct',
                                        });
                                        //Refresh List Fournisseur when add categories
                                        //this.getFournisseurBySearchKeyWord()
                                    }
                                }
                            });


                        }

                        // Status
                        if (this.formFilter.value.productOpenOrClosed) {
                            this.listIconFilter.push({
                                value: this.formFilter.value.productOpenOrClosed,
                                type: 'productOpenOrClosed',
                            });
                        }
                        if (this.formFilter?.value?.fournisseur) {
                            this._commonService.getFournissers().subscribe((res) => {
                                this.listNameSuppliers.forEach((item: any) => {
                                    this.listIconFilter.push({
                                        value:
                                            res?.find(
                                                (supplier: any) => supplier?.code === item
                                            )?.companyName ?? item,
                                        type: 'fournisseur',
                                    });
                                });
                            })
                        }

                        if (
                            this.formFilter.value.developpementDurable?.length > 0 &&
                            this.formFilter.value.developpementDurable[0]
                        ) {
                            this.formFilter.value.developpementDurable.forEach((item: any) => {
                                this.listIconFilter.push({
                                    value: item?.label,
                                    type: 'developpementDurable',
                                });
                            });
                        }

                        if (
                            this.formFilter.value.autresInformations?.length > 0 &&
                            this.formFilter.value.autresInformations[0]
                        ) {
                            this.formFilter.value.autresInformations.forEach((item: any) => {
                                this.listIconFilter.push({
                                    value: item?.label,
                                    type: 'autresInformations',
                                });
                            });
                        }

                        if (this.formFilter.value.brand) {
                            const isBrandDuplicate = this.listIconFilter.some(
                                (icon) =>
                                    icon.value === this.formFilter.value.brand &&
                                    icon.type === 'brand'
                            );
                            if (!isBrandDuplicate) {
                                this.listIconFilter.push({
                                    value: this.formFilter.value.brand,
                                    type: 'brand',
                                    operator: 'OR',
                                });
                            }
                        }

                        //this.tempKeyworkSearch = this.formFilter.value.longDescription;
                        if (this.formFilter.value.keyworkSearch) {
                            const isKeywordDuplicate = this.listIconFilter.some(
                                (icon) =>
                                    icon.value === this.formFilter.value.keyworkSearch &&
                                    icon.type === 'keyworkSearch'
                            );
                            if (!isKeywordDuplicate) {
                                this.listIconFilter.push({
                                    value: this.tempKeyworkSearch?.length
                                        ? this.tempKeyworkSearch
                                        : this.formFilter.value.keyworkSearch,
                                    type: 'keyworkSearch',
                                });
                            }
                        }

                        if (this.formFilter.value.longDescription) {
                            const isKeyDuplicate = this.listIconFilter.some(
                                (icon) =>
                                    icon.value === this.formFilter.value.longDescription &&
                                    icon.type === 'longDescription'
                            );
                            if (!isKeyDuplicate) {
                                this.listIconFilter.push({
                                    value: this.formFilter.value.longDescription,
                                    type: 'longDescription',
                                });
                            }
                        }
                        this.handleFlagBackState()
                    });

                this.currentUrl = this.route.snapshot.url.join('/');
                if (this.currentUrl?.includes('catalogues/rechercher')) {
                    this.getClickSubEvent = this._commonService
                        .getClickEventSearch()
                        .pipe(takeUntil(this.destroy$))
                        .subscribe({
                            next: (data) => {
                                this.lastSaveEventSearchData = data;

                                if (!data) {
                                    return;
                                }
                                this.dataRechercher = data;

                                if (!this.formFilter) {
                                    return;
                                }

                                const filters = {
                                    developpementDurable: this.dataRechercher?.developpementDurable,
                                    autresInformations: this.dataRechercher?.autresInformations,
                                    fournisseur: this.dataRechercher?.fournisseur,
                                    brand: this.dataRechercher?.brand,
                                    keyworkSearch: this.dataRechercher?.keyworkSearch,
                                    countryOfManufacture: this.dataRechercher?.countryOfManufacture,
                                    longDescription: this.dataRechercher?.referenceProduct,
                                    categoryProduct: this.dataRechercher?.categoryProduct,
                                };

                                const filteredFilters = Object.fromEntries(
                                    Object.entries(filters).filter(
                                        ([_, value]) => value !== undefined
                                    )
                                );
                                this.formFilter.patchValue(filteredFilters);
                                if (this.dataRechercher?.categoryProduct) {
                                    this.idCategory = this.dataRechercher?.categoryProduct;
                                }
                            },
                        });
                }

                this.route.paramMap.subscribe((_params) => {
                    if (!this.idCategory) {
                        this.idCategory = this.route.snapshot.params['id'];
                        this.currentIdCategory = this.route.snapshot.params['id'];
                    }
                    this.getCategoryPage();
                });
            }
        });
    }

    handleFlagBackState() {
        this._commonService.getIsFlagBack().pipe(
            scan((acc, value) => ({ count: acc.count + 1, value }), { count: 0, value: false }),
            take(1)
        ).subscribe(({ count, value }) => {
            if (count === 1) {
                if (value === true) {
                    this._commonService.setIsFlagBack(false);
                } else {
                    const filter = this.formFilter.getRawValue();
                    const result = handleRemoveProperties(filter)
                    const isEmptyObject = Object.keys(result).length === 0
                    if (!isEmptyObject) {
                        this.filterService.setFilters(this.formFilter);
                        this.setQueryParamFilter();
                    }
                }
            }
        });
        this._commonService.getIsFlagBack().pipe(
            skip(1)
        ).subscribe(res => {
            this._commonService.setIsFlagBack(false)
        });
    }

    renderIconFilter() {
        this.listIconFilter = [];

        if (this.formFilter.value.countryOfManufacture) {
            this.listIconFilter.push({
                value: this.formFilter.value.countryOfManufacture,
                type: 'countryOfManufacture',
            });
        }

        if (this.formFilter?.value?.categoryProduct) {
            let nameCatalog = '';
            this._commonService.getFlatCategories().subscribe((res: Category[]) => {
                if (res?.length) {
                    nameCatalog = res?.filter(
                        (el) => el?.codeCategory === this.formFilter?.value?.categoryProduct
                    )?.[0]?.nameCategory?.fr_FR;
                    const iscategoryProductDuplicate = this.listIconFilter.some(
                        (icon) => icon.type === 'categoryProduct'
                    );

                    if (!iscategoryProductDuplicate) {
                        this.listIconFilter.push({
                            value: nameCatalog,
                            type: 'categoryProduct',
                        });
                    }
                }
            });
        }

        // Status
        if (this.formFilter.value.productOpenOrClosed) {
            this.listIconFilter.push({
                value: this.formFilter.value.productOpenOrClosed,
                type: 'productOpenOrClosed',
            });
        }

        if (this.listNameSuppliers.length > 0) {
            this.listNameSuppliers.forEach((item: string) => {
                this.listIconFilter.push({
                    value:
                        this.listSuppliers.find(
                            (supplier: { code: string }) => supplier.code === item
                        )?.companyName ?? item,
                    type: 'fournisseur',
                });
            });
        }

        if (this.formFilter.value?.fournisseur?.length) {
            this._commonService.getFournissers().subscribe((res) => {
                if (res) {
                    this.formFilter.value?.fournisseur?.forEach((el: string) =>
                        this.listIconFilter.push({
                            value:
                                res?.find(
                                    (supplier: { code: string }) => supplier.code === el
                                )?.companyName ?? el,
                            type: 'fournisseur',
                        })
                    );
                }
            })
        }

        if (
            this.formFilter.value.developpementDurable?.length > 0 &&
            this.formFilter.value.developpementDurable[0]
        ) {
            this.formFilter.value.developpementDurable.forEach((item: any) => {
                this.listIconFilter.push({
                    value: item?.label,
                    type: 'developpementDurable',
                });
            });
        }

        if (
            this.formFilter.value.autresInformations?.length > 0 &&
            this.formFilter.value.autresInformations[0]
        ) {
            this.formFilter.value.autresInformations.forEach((item: any) => {
                this.listIconFilter.push({
                    value: item?.label,
                    type: 'autresInformations',
                });
            });
        }

        if (this.formFilter.value.brand) {
            const isBrandDuplicate = this.listIconFilter.some(
                (icon) => icon.value === this.formFilter.value.brand && icon.type === 'brand'
            );
            if (!isBrandDuplicate) {
                this.listIconFilter.push({
                    value: this.formFilter.value.brand,
                    type: 'brand',
                });
            }
        }

        if (this.formFilter.value.keyworkSearch) {
            const isKeywordDuplicate = this.listIconFilter.some(
                (icon) =>
                    icon.value === this.formFilter.value.keyworkSearch &&
                    icon.type === 'keyworkSearch'
            );
            if (!isKeywordDuplicate) {
                this.listIconFilter.push({
                    value: this.formFilter.value.keyworkSearch,
                    type: 'keyworkSearch',
                });
            }
        }

        if (this.formFilter.value.longDescription) {
            const isKeyDuplicate = this.listIconFilter.some(
                (icon) =>
                    icon.value === this.formFilter.value.longDescription &&
                    icon.type === 'longDescription'
            );
            if (!isKeyDuplicate) {
                this.listIconFilter.push({
                    value: this.formFilter.value.longDescription,
                    type: 'longDescription',
                });
            }
        }
    }

    ngOnDestroy(): void {
        this.getClickSubEvent && this.getClickSubEvent.unsubscribe();

        if (this.formFilter.value) {
            this._commonService.setFilterByKey('categories', {
                ...this.formFilter.value,
                categoryProductLabel: this.dataRechercher?.categoryProductLabel,
            });
        }
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnInit() {
        this.currentUrl = this.route.snapshot.url.join('/');
        this.idSupplier = this.currentUrl.startsWith('catalogues/suppliers')
            ? this.route.snapshot.params['id']
            : '';
        this.checkRouterShowHide();

        window.addEventListener('scroll', this.onWindowScroll.bind(this));
        if (
            this.currentUrl?.includes('catalogues') &&
            !this.currentUrl?.includes('catalogues/suppliers')
        ) {
            this.checkRouterCategories = true;
            this.checkRouterSupplier = false;
        }
        if (this.currentUrl.includes('catalogues/suppliers')) {
            this.checkRouterCategories = false;
            this.checkRouterSupplier = true;
        }
        if (this.currentUrl.includes('catalogues/rechercher')) {
            this.checkRouterCategories = false;
            this.checkRouterSupplier = false;
            this.checkRouterRechercher = true;
        }
        this.comparatorRepository.comparatorItemList$.subscribe((value) => {
            this.comparatorItemList = value;
        });

        this.route.queryParams.subscribe((params) => {
            this.homeUrl = params
        });

        window.addEventListener('popstate', (event: PopStateEvent) => {

            const state = window.history.state;

            if (state && state.filter) {
                this.updateUIBasedOnFilters(state.filter);

                if (state.homeUrl && this.isLastBackState(state)) {
                    window.location.href = state.homeUrl;
                }
            } else {
                this.clearAllFilters();
                if (state && state.homeUrl) {
                    window.location.href = state.homeUrl;
                }
            }
        });

        //this.getFournisseurBySearchKeyWord()
    }

    @HostListener('window:scroll', ['$event'])
    onWindowScroll(_event: Event) {
        this.scrollYPosition = window.scrollY;
        const element = this.wrapFilter?.nativeElement;
        const eleContent = this.wrapContent?.nativeElement;
        if (element) {
            if (element.offsetHeight < eleContent.offsetHeight) {
                const elementRect = element.getBoundingClientRect();
                const windowScrollTop =
                    window.pageYOffset ||
                    document.documentElement.scrollTop ||
                    document.body.scrollTop ||
                    0;
                const elementPositionTop = elementRect.top + windowScrollTop;

                if (window.scrollY + 205 >= elementPositionTop) {
                    this.condition = true;
                } else {
                    this.condition = false;
                }
            }
        }
    }

    clearAllFilters(): void {
        this.dataRechercher = null;
        this._commonService.sendClickEventSearch({});
        this.filterService.clearFilters();
        this.formFilter.reset({}, { emitEvent: false });
    }

    isLastBackState(state: any): boolean {
        return !!state.homeUrl && !state.filter;
    }
    updateUIBasedOnFilters(filter: any): void {
        this.formFilter.patchValue(filter, { emitEvent: false });
    }

    setQueryParamFilter(): void {
        const filter = this.filterService.getFilters();

        if (filter) {
            const result = handleRemoveProperties(filter)

            const currentQueryParams: any = this.route.snapshot.queryParams;

            if (Object.keys(result).length > 0) {
                const newFilterString = JSON.stringify(result);

                if (decodeURIComponent(currentQueryParams.filter) !== newFilterString) {
                    const newUrl = buildUrlWithNewParams(result);

                            /* if (!window.history.state || !window.history.state.filter) {
                                window.history.replaceState(
                                    { filter: result, homeUrl: this.homeUrl },
                                    '', 
                                    newUrl 
                                );
                            } else */ if (JSON.stringify(window.history.state.filter) !== newFilterString) {

                        window.history.pushState(
                            { filter: result, homeUrl: this.homeUrl },
                            '',
                            newUrl
                        );
                    }
                }
            } else {
                const queryParams = new URLSearchParams(window.location.search);
                queryParams.delete('filter');

                const newUrl = queryParams.toString()
                    ? `${window.location.pathname}?${queryParams.toString()}`
                    : window.location.pathname;

                if (window.location.href !== newUrl) {
                    window.history.pushState({}, '', newUrl);
                }
            }
        }
    }



    getFilterFromUrl(): void {
        const queryParams: any = this.route.snapshot.queryParams;

        if (queryParams.filter) {
            try {
                const decodedFilter = decodeURIComponent(queryParams.filter);
                const filterFromUrl = JSON.parse(decodedFilter);

                this.filterService.setFilters(filterFromUrl);
            } catch (e) {
                this.filterService.clearFilters();
            }
        } else {
            this.filterService.clearFilters();
        }
    }

    initForm(isSaveFilter: boolean): void {
        this.formFilter = this._fb.group({
            status: [],
            // clpSafetyPicto: null,
            // foodContact: null,
            // biocide: null,
            developpementDurable: [],
            autresInformations: [],
            categoryProduct: [],
            brand: '',
            keyworkSearch: '',
            fournisseur: [],
            productOpenOrClosed: '',
            countryOfManufacture: '',
            longDescription: '',
            shortDescription:''
        });

        this.formPagination = this._fb.group({
            rows: [12],
            page: [1],
        });
    }

    toggleShow(): void {
        this.showListBtn = !this.showListBtn;
    }

    checkRouterShowHide(): void {
        if (this.currentUrl.startsWith('catalogues/suppliers')) {
            this.dynamicDocumentService
                .find({
                    collectionName: 'dynamic_legal_entity',
                    filters: [
                        {
                            fieldName: 'code',
                            conditions: [
                                {
                                    type: 'EQUALS',
                                    value: this.idSupplier,
                                },
                            ],
                        },
                    ],
                    page: 1,
                    pageSize: 150,
                })
                .subscribe((res: any) => {
                    this.detailSupplier = res?.content[0];

                    this.checkListBySupplier = true;
                });
        } else {
            this.checkListBySupplier = false;
        }
    }

    ngAfterViewInit() {
        this.updatePaginators(this.currentPage);
    }

    onPageChange3(event: PageEvent) {
        if (this.isUpdating) {
            return;
        }
        this.isUpdating = true;
        this.currentPage = event.page;
        this.listUrlImageProduct = [];
        this.listNameCompany = [];
        this.listPriceProduct = [];
        this.rows3 = this.formPagination.value.rows;
        this.formPagination.patchValue({
            page: event.page + 1,
        });
        this.paginator1?.changePage(this.currentPage);
        this.paginator2?.changePage(this.currentPage);
        this.filterProduct();
        this.containerCategories?.nativeElement?.scrollIntoView({ behavior: 'smooth' });
    }

    updatePaginators(page: number) {
        this.paginator1?.changePage(page);
        this.paginator2?.changePage(page);
    }

    toggleStatus(value: string, event: any): void {
        if (value === 'OUVERT' && event.checked) {
            this.femeControl.setValue(false);
        } else if (value === 'FERMÉ' && event.checked) {
            this.ouvertControl.setValue(false);
        }

        if (event.checked?.length > 0) {
            this.formFilter.patchValue({
                productOpenOrClosed: event.checked[0],
            });
        } else {
            this.formFilter.patchValue({
                productOpenOrClosed: '',
            });
        }
    }

    delTag(item: any) {
        const index = this.listIconFilter.findIndex((e) => e === item);
        if (index !== -1) {
            this.listIconFilter.splice(index, 1);
        }
        switch (item.type) {
            case 'countryOfManufacture':
                this.formFilter.patchValue({ countryOfManufacture: null });
                break;

            case 'brand':
                this.formFilter.patchValue({ brand: null });
                break;
            case 'longDescription':
                this.formFilter.patchValue({ longDescription: null });
                this.getFournisseurBySearchKeyWord()
                break;
            case 'productOpenOrClosed':
                this.formFilter.patchValue({ productOpenOrClosed: '' });
                this.ouvertControl.setValue(false);
                this.femeControl.setValue(false);
                break;
            case 'fournisseur':
                const currentFournisseurs = this.formFilter.value.fournisseur || [];
                let delSupplier: any
                this._commonService.getFournissers().subscribe((res) => {
                    delSupplier = res?.find(
                        (supplier: any) => supplier?.companyName === item.value
                    );
                })
                this.formFilter.patchValue({
                    fournisseur: currentFournisseurs.filter((f: any) => f !== delSupplier?.code),
                });
                break;
            case 'developpementDurable':
                const currentDeveloppementDurable =
                    this.formFilter.value.developpementDurable || [];
                this.formFilter.patchValue({
                    developpementDurable: currentDeveloppementDurable.filter(
                        (d: any) => d.label !== item.value
                    ),
                });
                break;
            case 'autresInformations':
                const currentAutresInformations = this.formFilter.value.autresInformations || [];
                this.formFilter.patchValue({
                    autresInformations: currentAutresInformations.filter(
                        (d: any) => d.label !== item.value
                    ),
                });
                break;
            case 'categoryProduct':
                this.dataRechercher && (this.dataRechercher['categoryProduct'] = null);
                this.idCategory = null;
                this.subArrayCategory = [];
                this.formFilter.patchValue({ categoryProduct: null });
                //Refresh List Fournisseur when clear Categories
                this.getFournisseurBySearchKeyWord()
                break;

            case 'keyworkSearch':
                this.formFilter.patchValue({ keyworkSearch: '' });
                this.tempKeyworkSearch = '';
                this.tempKeyworkSearchChange.next('');
                break;
        }
    }

    clearFilter(): void {
        this.listIconFilter = [];

        this.formFilter.patchValue({
            developpementDurable: [],
            autresInformations: [],
            categoryProduct: null,
            productOpenOrClosed: '',
            fournisseur: [],
            brand: '',
            keyworkSearch: '',
            countryOfManufacture: ''
        });
        this.ouvertControl.setValue(false);
        this.femeControl.setValue(false);

        if (this.dataRechercher?.categoryProduct || this.dataRechercher?.referenceProduct) {
            this.subArrayCategory = [];
            this.idCategory = null;
        }
        this.dataRechercher = null;
    }

    filterRows(): void {
        this.listUrlImageProduct = [];
        this.listNameCompany = [];
        this.listPriceProduct = [];
        this.formPagination.patchValue({
            rows: this.formPagination.value.rows,
            page: 1,
        });

        this.paginator1?.changePage(0);

        if (this.isUpdating == false) {
            this.filterProduct();
        }
    }

    clickLevel1Category(event: any, value: any) {
        event.stopPropagation();

        if (this.isClickOnIconArrow([...event?.target?.classList])) {
            return;
        }

        // Change title of the product list category name
        if (value?.nameCategory.fr_FR != null && value?.nameCategory.fr_FR) {
            this.titleCategory = value?.nameCategory.fr_FR;
        }
        // Change logo of the category
        if (value?.pictoOfTheCategory[0]?.url != null && value?.pictoOfTheCategory[0]?.url) {
            this.titleCategoryImage = value?.pictoOfTheCategory[0]
                ? value?.pictoOfTheCategory[0].url
                : this.defaultImg;
        } else {
            this.titleCategoryImage = this.defaultImg;
        }

        // change router
        if (!this.checkListBySupplier && !this.checkRouterRechercher) {
            this._location.go('/catalogues/' + value?.codeCategory);
            this.currentIdCategory = value?.codeCategory;
        }

        this.formFilter.patchValue({
            categoryProduct: value.codeCategory,
        });

        this.addIconWhenClickCateLevel(this.titleCategory);
        this.refreshBreadcrumbs(value.id);
        this.getFournisseurBySearchKeyWord()

        // this.filterProduct("level 1"); not use
    }

    categoryOnlyFilter(code: string) {
        let dataTransfer;
        this._commonService.getFlatCategories().subscribe((res) => {
            const tree = buildCategoryHierarchyRandom(res);
            const findNode = findCategoryByTree(code, tree);
            dataTransfer = this.extractValues([findNode]);
        });
        return dataTransfer;
    }

    getProductOfCategoryLevel2(event: any, value: any, categoriesLV1: any, data: any) {
        event.stopPropagation();

        if (this.isClickOnIconArrow([...event?.target?.classList])) {
            return;
        }

        if (categoriesLV1?.nameCategory.fr_FR != null && categoriesLV1?.nameCategory.fr_FR) {
            this.titleCategory = categoriesLV1?.nameCategory.fr_FR;
        }

        if (
            categoriesLV1?.pictoOfTheCategory[0]?.url != null &&
            categoriesLV1?.pictoOfTheCategory[0]?.url
        ) {
            this.titleCategoryImage = categoriesLV1?.pictoOfTheCategory[0]
                ? categoriesLV1?.pictoOfTheCategory[0]?.url
                : this.defaultImg;
        } else {
            this.titleCategoryImage = this.defaultImg;
        }

        // change router
        if (!this.checkListBySupplier && !this.checkRouterRechercher) {
            this._location.go('/catalogues/' + categoriesLV1?.codeCategory);
            this.currentIdCategory = categoriesLV1?.codeCategory;
        }

        this.formFilter.patchValue({
            categoryProduct: value,
        });

        this.addIconWhenClickCateLevel(data?.nameCategory?.['fr_FR']);
        this.refreshBreadcrumbs(data.id);
        this.getFournisseurBySearchKeyWord()

    }

    getProductOfCategoryLevel3(event: any, value: any, categoriesLV1: any, data: any) {
        event.stopPropagation();

        if (this.isClickOnIconArrow([...event?.target?.classList])) {
            return;
        }

        if (categoriesLV1?.nameCategory.fr_FR != null && categoriesLV1?.nameCategory.fr_FR) {
            this.titleCategory = categoriesLV1?.nameCategory.fr_FR;
        }

        if (
            categoriesLV1?.pictoOfTheCategory[0]?.url != null &&
            categoriesLV1?.pictoOfTheCategory[0]?.url
        ) {
            this.titleCategoryImage = categoriesLV1?.pictoOfTheCategory[0]
                ? categoriesLV1?.pictoOfTheCategory[0].url
                : this.defaultImg;
        } else {
            this.titleCategoryImage = this.defaultImg;
        }

        // change router
        if (!this.checkListBySupplier && !this.checkRouterRechercher) {
            this._location.go('/catalogues/' + categoriesLV1?.codeCategory);
            this.currentIdCategory = categoriesLV1?.codeCategory;
        }

        this.formFilter.patchValue({
            categoryProduct: value,
        });

        this.addIconWhenClickCateLevel(data?.nameCategory?.['fr_FR']);
        this.refreshBreadcrumbs(data.id);
        this.getFournisseurBySearchKeyWord()
    }

    addIconWhenClickCateLevel(categoryName: string) {
        if (this.checkRouterCategories) {
            return;
        }

        if (!this.dataRechercher) {
            this.dataRechercher = {};
        }

        if (this.formFilter.value.categoryProduct && categoryName) {
            this.dataRechercher['categoryProduct'] = this.formFilter.value.categoryProduct;
            this.dataRechercher['categoryProductLabel'] = categoryName;
        }
    }

    isClickOnIconArrow(classList: string[]) {
        const arrowClassCheckList = ['p-panel-header-icon', 'p-panel-toggler', 'pi', 'pi-minus'];
        let rs =
            classList?.some((className: string) => arrowClassCheckList.includes(className)) ??
            false;
        return rs;
    }

    getCategoryPage(): void {
        if (
            this.currentUrl?.includes('catalogues') &&
            !this.currentUrl?.includes('catalogues/suppliers') &&
            !this.currentUrl?.includes('catalogues/rechercher')
        ) {
            this.idCategory = this.route.snapshot.params['id'];
            // retrieve category
        }

        let filters = [
            {
                fieldName: 'statusCategory',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: 'Publié',
                    },
                ],
            },
            {
                //  retrieve main category
                fieldName: 'codeCategory',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: this.idCategory,
                    },
                ],
            },
        ];

        this.dynamicDocumentService
            .find(
                {
                    collectionName: 'dynamic_category',
                    filters: filters,
                    sorts: {},
                    page: 1,
                    pageSize: 150,
                },
                true
            )
            .subscribe({
                next: (res) => {
                    if (res?.content.length > 0) {
                        if (
                            res?.content[0]?.nameCategory.fr_FR != null &&
                            res?.content[0]?.nameCategory.fr_FR
                        ) {
                            this.titleCategory = res?.content[0]?.nameCategory.fr_FR;
                            this.codeCategoryCurrent = res?.content[0]?.codeCategory;
                        }
                        if (
                            res?.content[0]?.pictoOfTheCategory?.[0]?.url != null &&
                            res?.content[0]?.pictoOfTheCategory[0]?.url
                        ) {
                            this.titleCategoryImage = res?.content[0]?.pictoOfTheCategory[0]
                                ? res?.content[0]?.pictoOfTheCategory[0]?.url
                                : this.defaultImg;
                        } else {
                            const level1Code = res?.content[0]?.codeCategory?.split('.')[0];
                            level1Code && this.getLevel1Category(level1Code);
                        }

                        this.idRootCategory = res?.content[0]?.id;

                        this.refreshBreadcrumbs(res?.content[0]?.id);

                    } else {
                        this.filterProduct();
                    }
                    this._cdf.detectChanges();
                },
                error: (_error) => {
                    //Fetch list Fournisser when have category code
                    this.getFournisseurBySearchKeyWord()
                },
                complete: () => {
                    //Fetch list Fournisser when have category code
                    this.getFournisseurBySearchKeyWord()
                }
            });
    }

    getBodyFournisseurFilters() {

        let filters: any = [];

        if (this.formFilter.value.longDescription || this.formFilter.value.keyworkSearch) {
            const longDescriptionValue = this.formFilter.value.longDescription;
            const keyworkSearchValue = this.formFilter.value.keyworkSearch;

            if (longDescriptionValue && keyworkSearchValue) {
                filters = [...filters, ...this.getParamSearchFilters(longDescriptionValue)];
            } else {
                const valueToUse = longDescriptionValue || keyworkSearchValue;
                filters = [...filters, ...this.getParamSearchFilters(valueToUse)];
            }
        }

        filters.push({
            fieldName: 'statusProduct',
            conditions: [
                {
                    type: 'EQUALS',
                    value: 'Publié',
                },
            ],
        });

        if (
            this.currentUrl?.includes('catalogues') &&
            !this.currentUrl?.includes('catalogues/suppliers') &&
            !this.currentUrl?.includes('catalogues/rechercher')
        ) {
            let condition;

            if (this.formFilter.value.categoryProduct) {
                const dataByCurrentIdCategory: any = this.categoryOnlyFilter(
                    this.currentIdCategory
                );

                const exists = dataByCurrentIdCategory!.some(
                    (item: any) => item?.value === this.formFilter.value.categoryProduct
                );
                if (exists) {
                    condition = this.categoryOnlyFilter(this.formFilter.value.categoryProduct);
                } else {
                    condition = this.categoryOnlyFilter(this.currentIdCategory);
                }
            } else {
                condition = this.categoryOnlyFilter(this.currentIdCategory);
            }

            filters.push({
                fieldName: 'categoryCode',
                conditions: condition,
            });
        } else if (this.formFilter.value.categoryProduct) {
            const condition = this.categoryOnlyFilter(this.formFilter.value.categoryProduct);
            filters.push({
                fieldName: 'categoryCode',
                conditions: condition,
            });
        }

        const body = [
            ...filters,
        ];

        return body
    }

    getBodyFilters() {
        let developpementDurableData: any[] = [];
        let autresInformationsData: any[] = [];
        let categoryProduct: any[] = [];
        let valueSupplier: any[] = [];
        let filters: any = [];

        if (this.formFilter.value.longDescription || this.formFilter.value.keyworkSearch) {
            const longDescriptionValue = this.formFilter.value.longDescription;
            const keyworkSearchValue = this.formFilter.value.keyworkSearch;

            if (longDescriptionValue && keyworkSearchValue) {
                filters = [...filters, ...this.getParamSearchFilters(longDescriptionValue)];


            } else {
                const valueToUse = longDescriptionValue || keyworkSearchValue;
                filters = [...filters, ...this.getParamSearchFilters(valueToUse)];
            }
        }

        if (this.formFilter.value.brand) {
            filters.push({
                fieldName: 'brand',
                operator: 'AND',
                conditions: [
                    {
                        type: 'CONTAINS',
                        value: this.formFilter.value.brand,
                    },
                ],
            });
        }

        filters.push({
            fieldName: 'statusProduct',
            conditions: [
                {
                    type: 'EQUALS',
                    value: 'Publié',
                },
            ],
        });

        if (
            this.formFilter.value.developpementDurable != null &&
            this.formFilter.value.developpementDurable?.length > 0
        ) {
            developpementDurableData = this.formFilter.value.developpementDurable?.map(
                (item: any) => ({
                    fieldName: item.name,
                    conditions: [
                        {
                            type: 'EQUALS',
                            value: true,
                        },
                    ],
                })
            );
        }

        if (
            this.formFilter.value.autresInformations != null &&
            this.formFilter.value.autresInformations?.length > 0
        ) {
            autresInformationsData = this.formFilter.value.autresInformations?.map((item: any) => ({
                fieldName: item.name,
                conditions: [
                    {
                        type: 'EQUALS',
                        value: item.conditionValue,
                    },
                ],
            }));
        }

        if (
            this.currentUrl?.includes('catalogues') &&
            !this.currentUrl?.includes('catalogues/suppliers') &&
            !this.currentUrl?.includes('catalogues/rechercher')
        ) {
            let condition;

            if (this.formFilter.value.categoryProduct) {
                const dataByCurrentIdCategory: any = this.categoryOnlyFilter(
                    this.currentIdCategory
                );

                const exists = dataByCurrentIdCategory!.some(
                    (item: any) => item?.value === this.formFilter.value.categoryProduct
                );
                if (exists) {
                    condition = this.categoryOnlyFilter(this.formFilter.value.categoryProduct);
                } else {
                    condition = this.categoryOnlyFilter(this.currentIdCategory);
                }
            } else {
                condition = this.categoryOnlyFilter(this.currentIdCategory);
            }

            filters.push({
                fieldName: 'categoryCode',
                conditions: condition,
            });
        } else if (this.formFilter.value.categoryProduct) {
            const condition = this.categoryOnlyFilter(this.formFilter.value.categoryProduct);
            filters.push({
                fieldName: 'categoryCode',
                conditions: condition,
            });
        }

        if (this.formFilter.value.productOpenOrClosed) {
            filters.push({
                fieldName: 'productOpenOrClosed',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: this.formFilter.value.productOpenOrClosed,
                    },
                ],
            });
        }

        if (
            this.formFilter.value.clpSafetyPicto !== null &&
            this.formFilter.value.clpSafetyPicto !== undefined
        ) {
            if (this.formFilter.value.clpSafetyPicto) {
                // SANS CLP

                filters.push({
                    fieldName: 'clpSafetyPicto',
                    conditions: [
                        {
                            type: 'EQUALS',
                            value: 'SANS',
                        },
                    ],
                });
            }
        } else {
        }
        if (
            this.formFilter.value.foodContact !== null &&
            this.formFilter.value.foodContact !== undefined
        ) {
            // Contact alimentaire
            this.formFilter.value.foodContact &&
                filters.push({
                    fieldName: 'foodContact',
                    conditions: [
                        {
                            type: 'EQUALS',
                            value: true,
                        },
                    ],
                });
        }

        if (this.formFilter.value.biocide !== null && this.formFilter.value.biocide !== undefined) {
            // Non biocide
            this.formFilter.value.biocide &&
                filters.push({
                    fieldName: 'biocide',
                    conditions: [
                        {
                            type: 'EQUALS',
                            value: false,
                        },
                    ],
                });
        }

        let existingFilter = filters.find((filter: any) => filter.fieldName === 'nameSupplier');
        if (this.listNameSuppliers && this.listNameSuppliers.length > 0) {
            filters = filters.filter((filter: any) => filter.fieldName !== 'nameSupplier');

            const newConditions = this.listNameSuppliers.map((el) => ({
                type: 'EQUALS',
                value: el,
            }));

            if (existingFilter) {
                existingFilter.conditions = existingFilter.conditions.concat(newConditions);
            } else {
                filters.push({
                    fieldName: 'nameSupplier',
                    conditions: newConditions,
                });
            }
        } else if (this.listMemberCatalogSegmentation.length) {
            const condition = this.listMemberCatalogSegmentation?.map((el) => ({
                type: 'EQUALS',
                value: el,
            }));

            if (existingFilter) {
                existingFilter.conditions = existingFilter.conditions.concat(condition);
            } else {
                filters.push({
                    fieldName: 'nameSupplier',
                    conditions: condition,
                });
            }
        }

        if (this.formFilter.value.countryOfManufacture) {
            filters.push({
                fieldName: 'countryOfManufacture',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: this.formFilter.value.countryOfManufacture,
                    },
                ],
            });
        }

        if (this.formFilter.value?.fournisseur?.length && !this.listNameSuppliers?.length) {
            const conditions = this.formFilter.value?.fournisseur?.map((el: string) => ({
                type: 'EQUALS',
                value: el,
            }));
            filters.push({
                fieldName: 'nameSupplier',
                conditions: conditions,
            });
        }

        if (this.idSupplier) {
            valueSupplier = [
                {
                    fieldName: 'nameSupplier',
                    conditions: [
                        {
                            type: 'EQUALS',
                            value: this.idSupplier,
                        },
                    ],
                },
            ];
        } else if (this.listMemberCatalogSegmentation.length) {
            const isRedirectNav = sessionStorage.getItem('redirectNav');
            if (!isRedirectNav) {
                valueSupplier = [
                    {
                        fieldName: 'nameSupplier',
                        conditions: [
                            {
                                type: 'IN',
                                value: this.listMemberCatalogSegmentation,
                            },
                        ],
                    },
                ];
            }
        }

        const body = [
            ...filters,
            ...developpementDurableData,
            ...autresInformationsData,
            ...categoryProduct,
            ...valueSupplier,
        ];

        return body
    }

    filterProduct(): void {
        let filters2: any = [];
        let subFilters: any = [];
        const body = this.getBodyFilters()
        const longDescriptionValue = this.formFilter.value.longDescription;
        const keyworkSearchValue = this.formFilter.value.keyworkSearch;
        if (longDescriptionValue && keyworkSearchValue) {
            filters2 = this.getParamSearchFilters(keyworkSearchValue);
        }

        const requestPayload: any = {
            collectionName: 'dynamic_product',
            filters: body,
            subFilters: subFilters,
            sorts: { uniqueId: 'DESC' },
            page: this.formPagination.value.page,
            pageSize: this.formPagination.value.rows,
        };

        if (filters2.length) {
            requestPayload.operator = 'AND';
        }
        if (filters2.length) {
            requestPayload.filters2 = filters2;
        }

        // findProductSpecial should be pass filter in which conditions CONTAINS arranged first, EQUALS after
        this.dynamicDocumentService.findProductSpecial(requestPayload, true).subscribe({
            next: (res) => {
                this.isUpdating = false;
                this.listProduct = res.content;
                this.totalRecords = res.totalElements;
                this.rows3 = res.size;
                this.totalPages = Math.ceil(this.totalRecords / this.rows3);
                this.loadingProductList = false;

                forkJoin([]).subscribe((_results) => {
                    this.listProduct = this.listProduct?.map((product, index) => ({
                        ...product,
                        urlImage: [],
                    }));
                });
            },
            error: (_error) => {
                this.isUpdating = false;
                this.loadingProductList = false;
            },
        });
    }

    getParamSearchFilters(value?: string) {
        let filters: Filter[] = [];
        const fieldNameArr = ['uniqueId', 'supplierItemNumber', 'brand', 'longDescription','shortDescription'];

        fieldNameArr.forEach((field) => {
            let conditions: conditions[] = [];
            let operator: string | undefined;

            // Only longDescription
            operator = 'OR';
            conditions.push({
                type: field === 'uniqueId' ? 'EQUALS' : 'CONTAINS',
                value: value,
            });
            if (conditions.length) {
                filters.push({
                    fieldName: field,
                    operator: operator,
                    conditions: conditions,
                });
            }
        });
        return filters;
    }


    checkExistProductOfSupplierOnCategory(linkProductArray: any[], idSupplier: string) {
        if (!idSupplier) return true;

        if (Array.isArray(linkProductArray) && this.allProductLinkToSupplier?.length > 0) {
            return (
                linkProductArray.filter((product) =>
                    this.allProductLinkToSupplier.includes(product?.documentId)
                ).length > 0
            );
        }

        return false;
    }

    getListCountry(): void {
        this._homepageService.getCountry().subscribe({
            next: (res) => {
                const allCountrySupplierObj: any = {};
                this.listCountry = res?.map((item: any) => {
                    if (item?.valeur) {
                        allCountrySupplierObj[item.valeur] =
                            item?.mapLocalLibelle?.fr_FR ?? item.valeur;
                    }

                    return {
                        ...item,
                        label: item.mapLocalLibelle.fr_FR,
                    };
                });

                this.listIconFilter = this.listIconFilter?.map((icon) => {
                    if (icon?.type === 'countryOfManufacture') {
                        const newValue = allCountrySupplierObj[icon?.value]
                            ? allCountrySupplierObj[icon?.value]
                            : icon.value;
                        return { ...icon, value: newValue };
                    }
                    return icon;
                });
            },
            error: (_error) => { },
        });
    }

    getListImage(supplierItemNumber: any): Observable<string> {
        return this.dynamicDocumentService
            .find({
                collectionName: 'dynamic_ressource',
                filters: [
                    {
                        fieldName: 'linkToProduct',
                        conditions: [
                            {
                                type: 'EQUALS',
                                value: supplierItemNumber,
                            },
                        ],
                    },
                ],
                sorts: {},
                page: 1,
                pageSize: 25,
            })
            .pipe(
                map((res: any) => {
                    const dataListImage = res.content;
                    const firstMatchingItem = dataListImage.find((item: any) => {
                        return item.typeOfResource?.value === 'PHOTO' && item.file?.length > 0;
                    });
                    return (
                        firstMatchingItem?.file[0]?.url ||
                        'src-adisco/assets/images/image-default.jpeg'
                    );
                })
            );
    }

    addProductToCompare(id?: string): void {
        let listProductCompare = JSON.parse(localStorage.getItem('compare') as any);

        if (listProductCompare?.length > 4) {
            this._messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Maximum 5 produits',
                life: 3000,
            });
            return;
        }
        if (!id) return;
        this.comparatorRepository.addProduct([id]);
    }

    getListSuppliers(): void {
        this.loadingIconStatus = true;
        let filters = [
            {
                fieldName: 'typeOfLegalEntity',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: 'FOURNISSEUR',
                    },
                ],
            },
            {
                fieldName: 'status',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: 'Publié',
                    },
                ],
            },
        ];

        if (this.listMemberCatalogSegmentation.length) {
            filters.push({
                fieldName: 'code',
                conditions: [
                    {
                        type: 'IN',
                        value: this.listMemberCatalogSegmentation as any,
                    },
                ],
            });
        }

        if (this.codeCategoryCurrent || this.formFilter.value.categoryProduct) {
            filters.push({
                fieldName: 'linkToCategories',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: this.formFilter.value.categoryProduct ? this.formFilter.value.categoryProduct : this.codeCategoryCurrent,
                    },
                ],
            });
        }

        this.dynamicDocumentService
            .find({
                collectionName: 'dynamic_legal_entity',
                filters: filters,
                sorts: {
                    companyName: 'ASC',
                },
                page: 1,
                pageSize: 150,
            })
            .subscribe((res: any) => {
                this.listSuppliers = res.content;

                const allSupplierObj: any = {};

                this.listSuppliers.forEach((sup) => {
                    if (sup?.code) {
                        allSupplierObj[sup.code] = sup?.companyName ?? sup.code;
                    }
                });

                this.listIconFilter = this.listIconFilter?.map((icon) => {
                    if (icon?.type === 'fournisseur') {
                        const newValue = allSupplierObj[icon?.value]
                            ? allSupplierObj[icon?.value]
                            : icon.value;
                        return { ...icon, value: newValue };
                    }
                    return icon;
                });
                this.loadingIconStatus = false;
            });
    }

    onExport(typeOfExport: string, page?: number) {
        let exportFileRequest: any = {
            filters: [],
            locales: ['fr_FR'],
            pageSize: 2000,
            page: page ? page + 1 : 1,
            sort: typeOfExport === 'PRODUCT' ? { longDescription: 'asc' } : { price: 'asc' },
        };

        if (typeOfExport === 'PRODUCT') {
            this.loadingExport.isExportProduct = true;

            exportFileRequest.filters.push({
                fieldName: 'statusProduct',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: 'Publié',
                    },
                ],
            });

            if (this.idSupplier) {
                exportFileRequest.filters.push({
                    fieldName: 'nameSupplier',
                    conditions: [
                        {
                            type: 'EQUALS',
                            value: this.idSupplier,
                        },
                    ],
                });
            }

            exportFileRequest.fields = [
                'uniqueId',
                'supplierItemNumber',
                'longDescription',
                'nameSupplier',
                'primaryPackagingDesignation',
                'numberOfProductsPerPrimaryPackaging',
                'primaryPackagingANumber',
                'primaryPackagingAUnitOfMeasurement',
                'unitWeightPrimary',
                'gencodeProduct',
                'secondaryPackagingDesignation',
                'totalWeightSecondary',
                'gencodeCarton',
                'tertiaryPackagingDesignation',
                'numberOfSecondaryPackagesPerTertiaryPackage',
                'palletWidth',
                'palletLength',
                'palletHeight',
                'palletWeight',
                'numberOfPalletsPerTruck',
                'quantityOfProductInKilog',
                'tgap',
                'deee',
                'customsNomenclature',
                'tunnelCode',
                'unCode',
                'unProperShippingName',
                'hazardClass',
                'packagingGroup',
            ];

        } else if (typeOfExport === 'PRICE') {
            this.loadingExport.isExportTariff = true;

            if (this.listIdTariff.length > 0) {
                exportFileRequest.filters.push({
                    fieldName: 'id',
                    conditions: [
                        {
                            type: 'IN',
                            value: this.listIdTariff,
                        },
                    ],
                });
            }

            exportFileRequest.filters.push({
                fieldName: 'year',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: 'N',
                    },
                ],
            },
                {
                    fieldName: 'nameSupplier',
                    conditions: [
                        {
                            type: 'EQUALS',
                            value: this.idSupplier,
                        },
                    ],
                });

            exportFileRequest.fields = [
                'linkToProduct',
                'priceCondition',
                'minimumPurchaseConditionUnit',
                'tertiaryCondition',
                'price',
                'priceLevel',
                'minimumQuantity',
                'applicationStartDate',
                'applicationEndDate',
            ];

            exportFileRequest.relationFields = {
                linkToProduct: ['uniqueId', 'supplierItemNumber', 'longDescription']
            };
        }

        let documentName = typeOfExport === 'PRODUCT' ? 'dynamic_product' : 'dynamic_tariff';
        let fileExtension = 'xlsx';

        const handleExportSuccess = (body: Blob) => {
            const nameExport =
                typeOfExport === 'PRICE' ? 'export_tarifs.xlsx' : 'export_articles.xlsx';
            const blob = new Blob([body], { type: 'application/vnd.ms-excel' });
            const objectUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = objectUrl;
            link.download = nameExport;
            link.click();
            URL.revokeObjectURL(objectUrl);

            if (typeOfExport === 'PRODUCT') {
                this.loadingExport.isExportProduct = false;
            } else {
                this.loadingExport.isExportTariff = false;
            }

            this.isExportSuccessFirst = true;
        };

        this.progress = 0;
        this.fileId = uuidv4();

        this._notificationService.subscribeExportFileNotification(this.fileId, (notification: any) => {
            if (notification.type === 'EXPORT_FILE_PROGRESS' && notification.fileId === this.fileId) {
                this.progress = Math.round(notification.progress * 100) / 100; // Round to 2 decimal places
            } else if (notification.type === 'EXPORT_FILE_REPORT' && notification.fileId === this.fileId) {
                this.progress = 100;

                const fileBytes = this.base64ToArrayBuffer(notification.report.fileContent);
                const blob = new Blob([fileBytes], { type: 'application/octet-stream' });

                setTimeout(() => {
                    handleExportSuccess(blob);
                    this.progress = 0;
                }, 1000);
            }
        });

        this.dynamicDocumentService.exportFileSupplierWithProgress(documentName, fileExtension, this.fileId, exportFileRequest).subscribe({
            next: () => this.progress = 0.01,
            error: () => { }
        });
    }

    getLevel1Category(codeCategory: any) {
        let filterCategories = [
            {
                fieldName: 'statusCategory',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: 'Publié',
                    },
                ],
            },
            {
                fieldName: 'codeCategory',
                conditions: [
                    {
                        type: 'EQUALS',
                        value: codeCategory,
                    },
                ],
            },
        ];
        this.dynamicDocumentService
            .find(
                {
                    collectionName: 'dynamic_category',
                    filters: filterCategories,
                    sorts: {},
                    page: 1,
                    pageSize: 1,
                },
                true
            )
            .subscribe((res: any) => {
                const imageURL = res.content[0]?.pictoOfTheCategory[0]?.url;
                if (imageURL) {
                    this.titleCategoryImage = imageURL;
                } else {
                    this.titleCategoryImage = this.defaultImg;
                }
            });
    }

    openDialog() {
        this.visibleDialog = true;
    }

    saveDialog() {
        this.visibleDialog = false;
    }

    refreshBreadcrumbs(idCategory: string) {
        if (!idCategory) {
            return;
        }

        const allLevel: any = {};
        const categoryCode = [{ id: idCategory }];

        this.summaryBreadcrumbs(categoryCode, allLevel);

        this.categoriesLevelList = Object.values(allLevel);
    }

    summaryBreadcrumbs(categoryCodeArr: any[], allLevel: any) {
        if (categoryCodeArr?.length) {
            categoryCodeArr.forEach((cate: any) => {
                const findCate = this.allCategoriesById[cate?.id ?? cate?.documentId];

                if (findCate && findCate?.categoryLevelCategory) {
                    if (!Array.isArray(allLevel[findCate.categoryLevelCategory]))
                        allLevel[findCate.categoryLevelCategory] = [];
                    if (
                        !allLevel[findCate.categoryLevelCategory].find(
                            (item: any) => item.id === findCate.id
                        )
                    )
                        allLevel[findCate.categoryLevelCategory].push(findCate);

                    if (
                        Array.isArray(findCate?.attachmentCategory) &&
                        findCate.attachmentCategory.length
                    ) {
                        this.summaryBreadcrumbs(findCate.attachmentCategory, allLevel);
                    }
                }
            });
        }
    }

    onApplySearch(searchValue: string) {
        this.formFilter.patchValue({
            keyworkSearch: searchValue,
        });
    }

    keyWorkSearchChange() {
        this.tempKeyworkSearchChange.next(this.tempKeyworkSearch);
    }

    fetchAllCategories() {
        this.loadingCategory = true;
        // if (this.idSupplier && this.currentUrl?.includes('catalogues/suppliers')) {
        //     tempSupplierId = this.idSupplier;
        // }
        if (this.idSupplier) {
            this.getCategoriesBySuplier([this.idSupplier]);
            this.loadingProductList = false;
        } else if (this.listMemberCatalogSegmentation?.length) {
            this._commonService.getStoreFilteredCategories().subscribe({
                next: (res) => {
                    const categoryFlat = flatCategories(res);
                    this._commonService.setFlatCategoriesByAllLevel(categoryFlat);
                    this.transformedArray = res;
                    this.loadingCategory = false;
                    let concatArr: any;

                    const catalog = res.filter(
                        (el: any) => el.codeCategory.toString() === this.idCategory
                    );
                    concatArr = this.extractValues(catalog);

                    this.subArrayCategory = this.subArrayCategory.concat(concatArr);
                    this.filterProduct();
                },
                error: () => {
                    this.loadingProductList = false;
                },
            });
        } else {
            this.dynamicDocumentService
                .getCategoryAllLevelStatusPublic(
                    this.listMemberCatalogSegmentation,
                    'linkToProduct'
                )
                .subscribe({
                    next: (res) => {
                        const result = res?.content;
                        this._commonService.setFlatCategoriesByAllLevel(res?.content);
                        const catalogTree = buildCategoryHierarchyRandom(result);
                        this.transformedArray = getProductsInCategory(catalogTree);
                        this.loadingCategory = false;
                        let concatArr;

                        if (this.idCategory) {
                            const catalog = catalogTree.filter(
                                (el: any) => el.codeCategory.toString() === this.idCategory
                            );
                            concatArr = this.extractValues(catalog);

                            this.subArrayCategory = concatArr;
                        }
                        this.filterProduct();
                    },
                    error: () => {
                        this.loadingCategory = false;
                        this.loadingProductList = false;
                    },
                });
        }
    }

    extractValues(tree: any[]): any[] {
        if (!tree) return [];
        return tree?.flatMap((node: any) => {
            const currentNodeValue = node?.codeCategory
                ? [{ type: 'EQUALS', value: node?.codeCategory }]
                : [];

            const subValues = node?.subcategoryList
                ? this.extractValues(node?.subcategoryList)
                : [];
            return [...currentNodeValue, ...subValues];
        });
    }

    onHideCalender() {
        this.calendar.overlayVisible = false;
    }

    checkProductExitsCart(event: MouseEvent, item: any) {
        const element = event.currentTarget as HTMLElement;
        if (this.hasExistProductToCard([item.id])) {
            element.classList.add('exit-product-cart');
        } else {
            element.classList.remove('exit-product-cart');
        }
    }

    hasExistProductToCard(productIds: any) {
        return this.comparatorRepository.currentComparator?.obj?.linkToProduct?.some((p: any) =>
            productIds.includes(p.documentId)
        );
    }

    getCategoriesBySuplier(suplier: string[]) {
        let categoryList: any;
        this.dynamicDocumentService
            .getCategoryAllLevelStatusPublic([], 'linkToProduct')
            .pipe(
                switchMap((result) => {
                    categoryList = result.content;
                    const filters = suplier
                        .map((el: string, index: number) => ({
                            fieldName: 'code',
                            operator: index > 0 ? 'OR' : undefined,
                            conditions: [
                                {
                                    type: 'EQUALS',
                                    value: el,
                                },
                            ],
                        }))
                        .map((filter) => {
                            if (filter.operator === undefined) {
                                delete filter.operator;
                            }
                            return filter;
                        });

                    return this.dynamicDocumentService
                        .find({
                            collectionName: 'dynamic_legal_entity',
                            filters: filters,
                            page: 1,
                            pageSize: suplier?.length,
                        })
                        .pipe(
                            map((item: any) => {
                                return item?.content.map((el: any) => el.linkToCategories);
                            })
                        );
                })
            )
            .subscribe({
                next: (res) => {
                    const categories = res.flatMap((item: any) => item);
                    const dataTransfer = removeDuplicatesAndSort(categories);

                    const findCategortList = findMatchingNodes(categoryList, dataTransfer);
                    this._commonService.setFlatCategoriesByAllLevel(findCategortList);
                    const result = buildCategoryHierarchyRandom(findCategortList);
                    this.transformedArray = getProductsInCategory(result);
                    this.loadingCategory = false;
                    this.filterProduct()
                },
                error: () => {
                    this.loadingCategory = false;
                },
            });
    }

    getFournisseurBySearchKeyWord() {
        const filters = this.getBodyFournisseurFilters()

        const body: DynamicReferencedFilterParam = {
            page: 1,
            pageSize: 100000,
            fields: ['companyName', 'code'],
            referencedDocumentName: "dynamic_product",
            referencedField: "nameSupplier",
            referencedFilters: filters,
            sorts: {},
            referencedTimezone: 0,
            referencedLocales: [
                "fr-FR"
            ]
        }
        this.dynamicDocumentService.getDynamicReferencedByFilter(body, 'dynamic_legal_entity').subscribe((res: any) => {
            this.listSuppliers = res.content;

            const allSupplierObj: any = {};

            this.listSuppliers.forEach((sup) => {
                if (sup?.code) {
                    allSupplierObj[sup.code] = sup?.companyName ?? sup.code;
                }
            });

            this.listIconFilter = this.listIconFilter?.map((icon) => {
                if (icon?.type === 'fournisseur') {
                    const newValue = allSupplierObj[icon?.value]
                        ? allSupplierObj[icon?.value]
                        : icon.value;
                    return { ...icon, value: newValue };
                }
                return icon;
            });
            this.loadingIconStatus = false;
        });
    }

    get shouldShowSpinner(): boolean {
        try {
            const element = this.renderer.selectRootElement('#outter-loading', true);
            return !!element;
        } catch (e) {
            return false;
        }
    }

    private base64ToArrayBuffer(base64: string): Uint8Array {
        const binaryString = window.atob(base64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes;
    }
}
